import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/client";
import { get, isNil } from "lodash";

import { getMemberCount } from "src/queries/group.graphql";
import GroupMemberCountBadge from "../GroupMemberCountBadge";

const MemberCountQueryBadge = ({
  groupId,
  isTotalMemberCount,
  showToolTip,
  toolTipPosition,
  hideWhenLoading,
  hideWhenZero,
}) => {
  const { data, error } = useQuery(getMemberCount, {
    variables: {
      groupId,
    },
    fetchPolicy: "cache-and-network",
    skip: !groupId,
  });

  const isLoading = isNil(data);
  const hasError = !isNil(error);
  if (!groupId) {
    return null;
  }
  if (hideWhenLoading && isLoading) {
    return null;
  }

  // Select the appropriate count based on the prop
  let count;
  if (isTotalMemberCount) {
    count = get(data, "group.memberCount", 0);
  } else {
    count = get(data, "group.directMemberCount", 0);
  }

  // Ensure count is always a number (safety check)
  count = typeof count === "number" ? count : 0;

  return (
    <GroupMemberCountBadge
      isLoading={isLoading}
      hasError={hasError}
      count={count}
      isTotalMemberCount={isTotalMemberCount}
      showToolTip={showToolTip}
      toolTipPosition={toolTipPosition}
      hideWhenZero={hideWhenZero}
    />
  );
};

MemberCountQueryBadge.propTypes = {
  groupId: PropTypes.string.isRequired,
  showToolTip: PropTypes.bool,
  toolTipPosition: PropTypes.string,
  hideWhenLoading: PropTypes.bool,
  hideWhenZero: PropTypes.bool,
  isTotalMemberCount: PropTypes.bool,
};

export default MemberCountQueryBadge;
